import IMask from 'imask';

class InputNumberMask {
    constructor(input) {
        this.input = input;
        this.inputConfig = {mask: Number};
        this.imask = IMask;

        this.init();
    }

    set config(input) {
        const {inputMaskConfig} = input.dataset;

        if (!inputMaskConfig) return;

        this.inputConfig = {...this.inputConfig, ...JSON.parse(inputMaskConfig)};
    }

    get config() {
        return this.inputConfig;
    }

    init() {
        this.config = this.input;
        this.imask(this.input, this.config);
    }
}

const inputNumberMask = {
    init() {
        const inputs = document.querySelectorAll('.js-input-number-mask');

        if (!inputs.length) return;

        this.inputNumberMaks = [];

        inputs.forEach((input) => {
            this.inputNumberMaks.push(new InputNumberMask(input));
        });
    },
};

export default inputNumberMask;
